import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import _ from 'underscore';
import { withTranslation } from 'react-i18next';
import CreateMarket from './CreateMarket';

class CreateMarketModal extends Component {
  render() {
    return (
      <Modal
        show={this.props.show}
        onHide={this.props.onHide}
        dialogClassName="modal-override"
      >
        <Modal.Header closeButton>
          <h4 className="pl-4">{this.props.t('MARKET_DETAILS')}</h4>
        </Modal.Header>
        <Modal.Body>
          <CreateMarket
            market={this.props.market}
            onHide={this.props.onHide}
            onSave={this.props.onSave}
            onEdit={this.props.onEdit}
            markets={this.props.markets}
          />
        </Modal.Body>
      </Modal>
    );
  }
}
export default withTranslation()(CreateMarketModal);
